import Vue from 'vue'

import Card from '~/components/global/card'
import VenueName from '~/components/global/venue-name'
import ShButtonDeprecated from '~/components/global/button'
import IconButton from '~/components/global/button/icon'
import EventStatus from '~/components/global/event-status'
import Icon from '~/components/global/icon'
import DateFormatter from '~/components/global/date-formatter'
import Checkbox from '~/components/global/checkbox'
import GenericError from '~/components/global/generic-error'
import Radio from '~/components/global/radio'
import RadioButton from '~/components/global/radio-button'
import ShSelect from '~/components/global/select'
import Stepper from '~/components/global/stepper'
import TextInput from '~/components/global/text-input'
import ShTextarea from '~/components/global/textarea'
import Modal from '~/components/global/modal'
import Blade from '~/components/global/modal/blade'
import ConfirmationModal from '~/components/global/modal/confirmation'
import LoadingModal from '~/components/global/modal/loading'
import DhLoadingIndicator from '~/components/global/loading-indicators/dh-loading-indicator'
import SmLoadingIndicator from '~/components/global/loading-indicators/small'
import ShFieldset from '~/components/global/fieldset'
import FormControl from '~/components/global/form-control'
import FormGroup from '~/components/global/form-group'
import Multiselect from '~/components/global/multiselect'
import Drawer from '~/components/global/modal/drawer'

const Components = {
  ShButtonDeprecated,
  Card,
  VenueName,
  IconButton,
  EventStatus,
  Icon,
  Checkbox,
  GenericError,
  Radio,
  RadioButton,
  ShSelect,
  Stepper,
  TextInput,
  ShTextarea,
  Modal,
  Blade,
  ConfirmationModal,
  DhLoadingIndicator,
  SmLoadingIndicator,
  DateFormatter,
  ShFieldset,
  FormControl,
  FormGroup,
  LoadingModal,
  Multiselect,
  Drawer
}

Object.keys(Components).forEach(name => {
  Vue.component(name, Components[name])
})
